module.exports = __webpack_public_path__ + "static/media/icon-piece2-4.7b496ac9.png";